import { createFileRoute } from '@tanstack/react-router';
import { useCan } from '@/features/auth/session.js';
import { DepositActionsBar } from '@/features/deposit-actions/deposit-actions-bar.js';
import { ResendMessageButton } from '@/features/deposit-actions/resend-message-button.js';
import { DepositDetailsPage } from '@/features/deposit-details/deposit-details-page.js';

export const Route = createFileRoute('/_app/deposits/$id')({
  component: DepositDetailsRoute,
});

function DepositDetailsRoute(): React.JSX.Element {
  const { id } = Route.useParams();
  const canResend = useCan('DEPOSIT_RESEND');
  return (
    <DepositDetailsPage
      id={id}
      actions={(deposit) => <DepositActionsBar deposit={deposit} />}
      messageActions={
        canResend
          ? (message) => <ResendMessageButton depositId={id} message={message} />
          : undefined
      }
    />
  );
}
